import React, { createContext, useContext, useState } from 'react';

const EnrollContext = createContext();

export function EnrollProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <EnrollContext.Provider value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}>
      {children}
    </EnrollContext.Provider>
  );
}

export const useEnroll = () => useContext(EnrollContext);
